import React, { useEffect, useState } from 'react';
export function TopBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 55
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  return <div className="bg-nutri-dark text-white text-center py-1.5 px-4 text-xs md:text-sm font-medium sticky top-0 z-50 shadow-md" data-id="element-285">
      Oferta de lanzamiento termina en:{' '}
      <span className="font-bold tabular-nums ml-1.5 bg-white/10 px-1.5 py-0.5 rounded" data-id="element-286">
        {formatTime(timeLeft.hours)}H : {formatTime(timeLeft.minutes)}M :{' '}
        {formatTime(timeLeft.seconds)}S
      </span>
    </div>;
}